<opac-dialog
  [size]="'xlarge'"
  [title]="externalVideoData()?.title"
  [open]="isOpen()"
  (closed)="closeDialog()">
  <div *ngIf="!externalVideoData()?.isIframeLink" [innerHTML]="externalVideoData()?.link | safe"></div>
  <iframe *ngIf="externalVideoData()?.isIframeLink" [src]="externalVideoData().link"></iframe>
</opac-dialog>
